import jsPDF from 'jspdf';
import profileImg from '../assets/transform.png';

const GOLD   = [212, 160, 23];
const ORANGE = [220, 90, 20];
const RED    = [200, 30, 30];
const BLACK  = [10, 10, 10];
const WHITE  = [255, 255, 255];
const DGRAY  = [80, 80, 80];

const mealPlans = {
  cut: {
    title: 'Fat Loss Diet Plan',
    subtitle: 'High Protein · Low Carb · Calorie Deficit',
    meals: [
      {
        time: '7:00 AM — Breakfast',
        items: ['4 Egg Whites + 1 Whole Egg (Boiled/Scrambled)', '2 Slices Whole Wheat Bread', '1 Cup Green Tea (no sugar)'],
        cal: 320, protein: 28, carbs: 30, fat: 8,
      },
      {
        time: '10:00 AM — Mid Morning Snack',
        items: ['1 Scoop Whey Protein (water)', '1 Small Apple or Banana'],
        cal: 180, protein: 25, carbs: 20, fat: 2,
      },
      {
        time: '1:00 PM — Lunch',
        items: ['150g Grilled Chicken / Paneer', '1 Cup Brown Rice or 2 Chapati', '1 Cup Mixed Vegetables (sabzi)', '1 Cup Buttermilk (chaas)'],
        cal: 480, protein: 40, carbs: 45, fat: 10,
      },
      {
        time: '4:00 PM — Pre-Workout',
        items: ['1 Banana', '5–6 Almonds', '1 Cup Black Coffee (optional)'],
        cal: 160, protein: 4, carbs: 28, fat: 5,
      },
      {
        time: '7:00 PM — Post-Workout',
        items: ['1 Scoop Whey Protein (milk/water)', '1 Slice Bread or Rice Cake'],
        cal: 200, protein: 28, carbs: 18, fat: 3,
      },
      {
        time: '9:00 PM — Dinner',
        items: ['150g Fish / Chicken / Tofu', '1 Cup Dal (lentils)', 'Large Salad (cucumber, tomato, onion)', '1 Chapati (optional)'],
        cal: 380, protein: 38, carbs: 28, fat: 8,
      },
    ],
    tips: [
      'Drink 3–4 litres of water daily',
      'Avoid sugar, fried food & processed snacks',
      'Eat slowly — stop at 80% full',
      'Sleep 7–8 hours for fat loss hormones',
      'Do 30 min cardio 4–5 days/week',
    ],
  },
  maintain: {
    title: 'Maintenance Diet Plan',
    subtitle: 'Balanced Macros · Sustainable Eating',
    meals: [
      {
        time: '7:00 AM — Breakfast',
        items: ['3 Whole Eggs (any style)', '2 Slices Whole Wheat Bread + Peanut Butter', '1 Glass Milk or Protein Shake'],
        cal: 480, protein: 30, carbs: 40, fat: 16,
      },
      {
        time: '10:30 AM — Mid Morning',
        items: ['1 Cup Greek Yogurt / Curd', '1 Fruit (banana / apple / mango)', 'Handful of Mixed Nuts'],
        cal: 280, protein: 14, carbs: 32, fat: 10,
      },
      {
        time: '1:00 PM — Lunch',
        items: ['200g Chicken / Paneer / Fish', '1.5 Cup Rice or 3 Chapati', '1 Cup Dal', '1 Cup Vegetables', 'Salad'],
        cal: 620, protein: 45, carbs: 65, fat: 12,
      },
      {
        time: '4:00 PM — Evening Snack',
        items: ['Peanut Butter Toast (2 slices)', '1 Banana', '1 Cup Tea / Coffee'],
        cal: 320, protein: 10, carbs: 42, fat: 12,
      },
      {
        time: '7:30 PM — Post-Workout / Dinner',
        items: ['150g Protein (chicken/fish/eggs/paneer)', '1 Cup Rice or 2 Chapati', '1 Cup Dal or Sabzi', 'Salad'],
        cal: 520, protein: 40, carbs: 50, fat: 10,
      },
    ],
    tips: [
      'Eat every 3–4 hours to keep metabolism active',
      'Match calorie intake to your TDEE',
      'Include all food groups — no extreme cuts',
      'Stay hydrated — 2.5–3 litres water/day',
      'Train 4–5 days/week (mix strength + cardio)',
    ],
  },
  bulk: {
    title: 'Muscle Gain Diet Plan',
    subtitle: 'High Protein · High Calorie · Calorie Surplus',
    meals: [
      {
        time: '7:00 AM — Breakfast',
        items: ['5 Whole Eggs (scrambled/omelette)', '3 Slices Whole Wheat Bread + Peanut Butter', '1 Glass Full-Fat Milk', '1 Banana'],
        cal: 720, protein: 42, carbs: 65, fat: 24,
      },
      {
        time: '10:00 AM — Mid Morning',
        items: ['1 Scoop Mass Gainer / Whey + Milk', '1 Cup Oats with Honey & Nuts', '1 Fruit'],
        cal: 480, protein: 30, carbs: 60, fat: 12,
      },
      {
        time: '1:00 PM — Lunch',
        items: ['250g Chicken / Mutton / Paneer', '2 Cups Rice or 4 Chapati', '1 Cup Dal', '1 Cup Vegetables', 'Curd'],
        cal: 820, protein: 55, carbs: 85, fat: 18,
      },
      {
        time: '4:00 PM — Pre-Workout',
        items: ['2 Bananas', '1 Scoop Whey Protein', '5–6 Dates', '1 Cup Coffee'],
        cal: 380, protein: 28, carbs: 55, fat: 4,
      },
      {
        time: '7:00 PM — Post-Workout',
        items: ['1.5 Scoop Whey Protein (milk)', '1 Cup White Rice or 2 Bread Slices', '1 Tbsp Honey'],
        cal: 420, protein: 40, carbs: 50, fat: 5,
      },
      {
        time: '9:30 PM — Dinner',
        items: ['200g Chicken / Fish / Eggs', '1.5 Cup Rice or 3 Chapati', '1 Cup Dal', 'Vegetables', '1 Glass Milk before bed'],
        cal: 680, protein: 50, carbs: 65, fat: 14,
      },
    ],
    tips: [
      'Eat every 2.5–3 hours — never skip meals',
      'Aim for 1g protein per pound of bodyweight',
      'Prioritize compound lifts (squat, bench, deadlift)',
      'Sleep 8+ hours — growth hormone peaks at night',
      'Track calories weekly and adjust if not gaining',
    ],
  },
};


export const generateDietPlanPDF = (result, form, goal) => {
  const plan = mealPlans[goal];
  const doc  = new jsPDF();
  const pw   = 210;
  let y      = 0;

  // ── Header banner ──────────────────────────────────────────────
  doc.setFillColor(...BLACK);
  doc.rect(0, 0, pw, 58, 'F');

  // Gold accent lines
  doc.setFillColor(...GOLD);
  doc.rect(0, 54, pw, 2.5, 'F');
  doc.setFillColor(...ORANGE);
  doc.rect(0, 56.5, pw, 1.5, 'F');

  // Profile image — larger, vertically centered
  try {
    doc.addImage(profileImg, 'PNG', 10, 4, 46, 46);
    // Gold border
    doc.setDrawColor(...GOLD);
    doc.setLineWidth(1.5);
    doc.rect(10, 4, 46, 46);
  } catch (e) { /* skip if image fails */ }

  // Name
  doc.setTextColor(...GOLD);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.text('COACH SABARI', 64, 17);

  // Divider under name
  doc.setFillColor(...ORANGE);
  doc.rect(64, 20, 60, 1, 'F');

  // Subtitle lines
  doc.setTextColor(...WHITE);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text('Rugged Fitness Trainer  |  Tamil Nadu, India', 64, 28);
  doc.text('YouTube: @Fitness_coach_129  |  IG: @sabari_prime_fit', 64, 36);

  // Goal badge
  doc.setFillColor(...ORANGE);
  doc.roundedRect(64, 41, 90, 10, 2, 2, 'F');
  doc.setTextColor(...WHITE);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text(plan.title.toUpperCase(), 109, 47.5, { align: 'center' });

  y = 68;

  // ── User stats bar ─────────────────────────────────────────────
  doc.setFillColor(245, 245, 245);
  doc.rect(14, y - 5, 182, 14, 'F');
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(...DGRAY);
  const stats = [
    `Weight: ${form.weight} kg`,
    `Height: ${form.height} cm`,
    `Age: ${form.age} yrs`,
    `Gender: ${form.gender}`,
    `Goal: ${plan.title}`,
    `Date: ${new Date().toLocaleDateString('en-IN')}`,
  ];
  stats.forEach((s, i) => doc.text(s, 18 + i * 32, y + 3));
  y += 18;

  // ── Target calories summary ────────────────────────────────────
  const boxes = [
    { label: 'Target Calories', val: `${result.target} kcal`, c: GOLD },
    { label: 'Protein',         val: `${result.protein} g`,   c: ORANGE },
    { label: 'Carbs',           val: `${result.carbs} g`,     c: [60, 140, 60] },
    { label: 'Fat',             val: `${result.fat} g`,       c: RED },
  ];
  const bw = 42, bh = 18, gap = 4, startX = 14;
  boxes.forEach((b, i) => {
    const bx = startX + i * (bw + gap);
    doc.setFillColor(...b.c);
    doc.rect(bx, y, bw, bh, 'F');
    doc.setTextColor(...WHITE);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(b.val, bx + bw / 2, y + 8, { align: 'center' });
    doc.setFontSize(6);
    doc.setFont('helvetica', 'normal');
    doc.text(b.label.toUpperCase(), bx + bw / 2, y + 14, { align: 'center' });
  });
  y += 26;

  // ── Meal Plan ──────────────────────────────────────────────────
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(...BLACK);
  doc.text('DAILY MEAL PLAN', 14, y);
  doc.setFillColor(...GOLD);
  doc.rect(14, y + 2, 182, 1, 'F');
  y += 10;

  plan.meals.forEach((meal, mi) => {
    // Meal header
    doc.setFillColor(...BLACK);
    doc.rect(14, y - 4, 182, 9, 'F');
    doc.setTextColor(...GOLD);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.text(meal.time, 18, y + 1);

    // Macros on right
    doc.setTextColor(...ORANGE);
    doc.setFontSize(7);
    doc.text(
      `${meal.cal} kcal  |  P: ${meal.protein}g  C: ${meal.carbs}g  F: ${meal.fat}g`,
      192, y + 1, { align: 'right' }
    );
    y += 10;

    // Food items
    meal.items.forEach((item, ii) => {
      if (ii % 2 === 0) { doc.setFillColor(250, 250, 250); doc.rect(14, y - 3.5, 182, 6.5, 'F'); }
      doc.setTextColor(...DGRAY);
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text(`  • ${item}`, 16, y + 1);
      y += 6.5;
    });
    y += 4;

    // Page break guard
    if (y > 255 && mi < plan.meals.length - 1) {
      doc.addPage();
      y = 20;
    }
  });

  // ── Tips ───────────────────────────────────────────────────────
  if (y > 230) { doc.addPage(); y = 20; }

  doc.setFillColor(...ORANGE);
  doc.rect(14, y - 4, 182, 9, 'F');
  doc.setTextColor(...WHITE);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('PRO TIPS FROM COACH SABARI', 18, y + 1);
  y += 12;

  plan.tips.forEach((tip, i) => {
    if (i % 2 === 0) { doc.setFillColor(255, 248, 235); doc.rect(14, y - 3.5, 182, 7, 'F'); }
    doc.setTextColor(...BLACK);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text(`  ${i + 1}. ${tip}`, 16, y + 1);
    y += 7;
  });

  // ── Footer ─────────────────────────────────────────────────────
  y += 8;
  doc.setFillColor(...BLACK);
  doc.rect(0, y, pw, 22, 'F');
  doc.setTextColor(...GOLD);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.text('Coach Sabari — Rugged Fitness', pw / 2, y + 7, { align: 'center' });
  doc.setTextColor(...WHITE);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.text('YouTube: @Fitness_coach_129  |  Instagram: @sabari_prime_fit  |  sabariprimefit@gmail.com', pw / 2, y + 13, { align: 'center' });
  doc.setTextColor(150, 150, 150);
  doc.setFontSize(6);
  doc.text('This plan is for general guidance. Consult a nutritionist for medical conditions.', pw / 2, y + 19, { align: 'center' });

  doc.save(`CoachSabari_${plan.title.replace(/ /g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};
